package fr.frux.feature.map.site

import androidx.compose.runtime.Composable
import androidx.compose.runtime.staticCompositionLocalOf
import androidx.lifecycle.viewmodel.compose.viewModel

/** Contrat de fabrique du [SiteLayerViewModel], honore par le composition root (#43). */
fun interface SiteLayerViewModelFactory {
    fun create(): SiteLayerViewModel
}

/** Sans defaut, comme celle du MapViewModel : un oubli de cablage doit casser au premier rendu. */
val LocalSiteLayerViewModelFactory =
    staticCompositionLocalOf<SiteLayerViewModelFactory> {
        error("SiteLayerViewModelFactory absente : le composition root doit l'installer (cf. FruxCompositionRoot, #43)")
    }

@Composable
fun rememberSiteLayerViewModel(): SiteLayerViewModel {
    val factory = LocalSiteLayerViewModelFactory.current
    return viewModel { factory.create() }
}
